/**
 * Fixed "today" so the dummy dataset's overdue/soon/on-track statuses are
 * reproducible. Swap this for `new Date()` once you're on live data.
 */
export const TODAY = new Date();

export function fmtDate(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(`${iso}T00:00:00`);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
}

export function daysFrom(value: string): number {
  if (value == null || value == undefined) {
    return 0;
  }
  const [day, month, year] = value.split('-').map(Number);

  const targetDate: Date = new Date(year, month - 1, day);
  targetDate.setHours(0, 0, 0, 0);

  const today: Date = new Date();
  today.setHours(0, 0, 0, 0);

  return Math.round(
    (today.getTime() - targetDate.getTime()) / (1000 * 60 * 60 * 24)
  );
}

export function isToday(iso: string | null): boolean {
  return iso !== null && daysFrom(iso) === 0;
}
